import { render, staticRenderFns } from "./addEducationHistory.vue?vue&type=template&id=3076d596&scoped=true"
import script from "./addEducationHistory.vue?vue&type=script&lang=js"
export * from "./addEducationHistory.vue?vue&type=script&lang=js"
import style0 from "./addEducationHistory.vue?vue&type=style&index=0&id=3076d596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3076d596",
  null
  
)

export default component.exports